import type { IconButtonProps } from '@mui/material';
import { CloseIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from './IconButton';

const CloseIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.close', 'Close');

    return (
      <IconButton
        ref={ref}
        {...props}
        tooltipTitle={tooltipTitle}
      >
        <CloseIcon color="inherit" fontSize={props.size} />
      </IconButton>
    );
  },
);

CloseIconButton.displayName = 'CloseIconButton';
export default CloseIconButton;
